 
//Product Points
const tlPDPoints = gsap.timeline({
    scrollTrigger: {
    trigger: ".product_points",
    start: "0%",
    end: "100%",
	scrub: true,
    start: "-40%",
    end: "40%",
    }
});

tlPDPoints.fromTo(
    ".product_points_texts",
  {  opacity: 0   },
  {  opacity: 1, duration: 2 } 
);

tlPDPoints.fromTo(
    ".product_points_img",
  {  translateX: "-10%" },
  {  translateX: 0, duration: 3 },
    "<"
);

tlPDPoints.fromTo(
    ".product_points_text1",
  {  opacity: 0.5, scale: 0.9 },
  {  opacity: 1, scale: 1, duration: 3 } 
);

tlPDPoints.fromTo(
    ".product_points_text2",
  {  opacity: 0.5, scale: 0.9 },
  {  opacity: 1, scale: 1, duration: 3 } 
);

tlPDPoints.fromTo(
    ".product_points_text1",
  {  opacity: 1, scale: 1},
  {  opacity: 0.5, scale: 0.9, duration: 3 },
    "<"
);


tlPDPoints.fromTo(
    ".product_points_text3",
  {  opacity: 0.5, scale: 0.9 },
  {  opacity: 1, scale: 1, duration: 3 } 
);

tlPDPoints.fromTo(
    ".product_points_text2",
  {  opacity: 1, scale: 1, translateY: 0},
  {  opacity: 0.5, scale: 0.9, duration: 3 },
    "<"
);


//Text Highlight Dark
const tlH = gsap.timeline({
  scrollTrigger: {
    trigger: ".text_highlight_dark",
    scrub: true,
    start: "-40%",
    end: "40%",
  },
});

tlH.fromTo(
  ".text_highlight_dark .highlight",
  { color: "rgba(255, 255, 255, 0.4" },
  { color: "rgba(255, 255, 255, 1", stagger: 1 }
);

const tlHRemove = gsap.timeline({
  scrollTrigger: {
    trigger: ".text_highlight_dark",
    scrub: true,
    start: "-20%",
    end: "60%",
  },
});


tlHRemove.to(".text_highlight_dark .highlight", { color: "rgba(255,255,255, 0.4", stagger: 1 });







//Sections load 

  

 


//ScrollTrigger.matchMedia({
	
  // large
 // "(min-width: 600px)": function() {

  


ScrollTrigger.matchMedia({
	
  // large
 "(min-width: 600px)": function() {

 
   gsap.utils.toArray(".delayload").forEach(element => {
  gsap.fromTo(element, {
    opacity: 0,
    y: 50,
  }, {
    scrollTrigger: {
      trigger: element,
      start: "top top+=500",
      end: '+=100',
    },
  opacity: 1,
  y: 0,
  });
});

 
  }
	
}); 
